import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row, VertAlert, VertButton, VertInput, VertRate, VertTypography } from "@vertem-core/vertice-ds";
import { SaveRating } from "../../Services/Apis/RatingProduct";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
const RatingForm = ({ onCancel, orderId, productSku, supplierId, handleConfirmationModal }) => {
    const oidc = useSelector(({ oidc }) => oidc)
    const [isLoading, setIsLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [rate, setRate] = useState(0.0)
    const [sellerRate, setSellerRate] = useState(0.0)
    const [productMessage, setProductMessage] = useState('')
    const [sellerMessage, setSellerMessage] = useState('')

    const handleSubmit = useCallback(() => {
        setIsLoading(true)
        const data = {
            product: {
                value: rate,
                comment: productMessage,
                productSku
            },
            supplier: {
                value: sellerRate,
                comment: sellerMessage,
                supplierId
            },
            orderId,
        }
        SaveRating(oidc?.user, data).then(() => {
            setError(false);
            handleConfirmationModal()
        }).catch((e) => {
            setError(true);
        }).finally(() => {
            setIsLoading(false);
        })
    }, [
        isLoading,
        rate,
        sellerRate,
        productMessage,
        sellerMessage,
        oidc,
        productSku,
        supplierId,
        orderId,
        onCancel,
        handleConfirmationModal
    ])


    const isValidForm = rate !== 0.0 && sellerRate !== 0.0

    return (<>
        {success && (
            <VertAlert
                size={'large'}
                type={'success'}
                message={'Obrigado, sua opinião é muito importante para melhora do nosso serviço'}
                closable={false}
                />
            )}

        {error && (
            <VertAlert
                size={'large'}
                type={'error'}
                className='disclaimer-error'
                message={'Não foi possível enviar sua avaliação, por favor, tente novamente em instantes.'}
                closable={false}
            />
        )}

        <form>
            <div className='padding-y-small'>
                <div >
                    <div className='rate-container'>
                        <VertTypography.Text className='rate-product-txt'>
                            Avalie o seu produto
                        </VertTypography.Text>
                        <VertRate
                            size='large'
                            id='rate-product'
                            onChange={(e) => {
                                setRate(e)
                            }}
                        />
                    </div>
                    <VertInput.TextArea
                        size='large'
                        maxLength={1100}
                        value={productMessage}
                        placeholder='Deixe um comentário sobre o produto'
                        className={'RatingProduct-textarea margin-y-small padding-y-small padding-x-extra-small'}
                        onChange={(e) => {
                            setProductMessage(e.target.value)
                        }}
                    />
                </div>
                <div >
                    <div className='rate-container'>
                        <VertTypography.Text className='rate-product-txt'>
                            Avalie o fornecedor
                        </VertTypography.Text>
                        <VertRate
                            size='large'
                            id='rate-product'
                            onChange={(e) => {
                                setSellerRate(e)
                            }}
                        />
                    </div>
                    <VertInput.TextArea
                        size='large'
                        maxLength={1100}
                        value={sellerMessage}
                        placeholder='Deixe um comentário sobre o fornecedor'
                        onChange={(e) => {
                            setSellerMessage(e.target.value)
                        }}
                        className={'RatingProduct-textarea margin-y-small padding-y-small padding-x-extra-small'}
                    />
                </div>
                <div style={{ maxWidth: '650px' }}>
                    <Row className='margin-x-none' justify='end'>
                        <VertButton
                            size='large'
                            type='detached'
                            loading={isLoading}
                            disabled={!isValidForm || success || error}
                            onClick={() => handleSubmit()}
                            className='rate-button-form'
                        >
                            ENVIAR
                        </VertButton>
                    </Row>
                </div>
            </div>
        </form>
    </>)
}

RatingForm.propTypes = {
    onCancel: PropTypes.func,
    handleConfirmationModal: PropTypes.func,
    productSku: PropTypes.string,
    supplierId: PropTypes.string,
    orderId: PropTypes.string,
}

export default RatingForm
